








































import {Component, Prop, Vue} from 'vue-property-decorator';
import ZCLogo from '../assets/logo.svg';
import {BadgeStore} from '@/store/modules/badge.store';
import { pick, map } from 'lodash';
import BadgeEdit from '@/components/BadgeEdit.vue';
import {WebService} from '@/services/web.service';
import {OverlayShowTime} from '@/constants';
import moment from 'moment';
// @ is an alias to /src

@Component({
	components: {
		ZCLogo,
		BadgeEdit
	}
})
export default class ManageBadges extends Vue {
	badgeName = '';
	sortBy = 'activationDate';
	sortDesc = true;
	fields = [
		{
			key: 'name',
			label: 'Badges',
			sortable: true,
			class: 'cursor-pointer'
		},
		{
			key: 'lastSeen',
			label: 'Last Seen',
			sortable: true,
			class: 'text-right cursor-pointer',
			formatter(timestamp: number) {
				const date = moment.unix(timestamp);
				if(moment().subtract(1, 'day').isBefore(date)) {
					return 'Yesterday ' + date.format('h:mmA');
				}
				return moment.unix(timestamp).format('MMM DD, YYYY h:mmA');
			}
		},
		{
			key: 'activationDate',
			label: 'Activation Date',
			sortable: true,
			class: 'text-right cursor-pointer',
			formatter(timestamp: number) {
				const date = moment.unix(timestamp);
				if(moment().subtract(1, 'day').isBefore(date)) {
					return 'Yesterday';
				}
				return moment.unix(timestamp).format('MMM DD, YYYY');
			}
		}
	];

	showBadge = false;
	clickedBadgeId = '';
	showLoading = false;
	showCompletedOverlay = false;
	overlayMessage = '';

	get badges() {
		return BadgeStore.badges.map((badge) => {
			return {
				id: badge.badgeId,
				name: badge.name,
				lastSeen: badge.lastSeenDate,
				activationDate: badge.activationDate
			};
		});
	}

	get validBadgeName() {
		return BadgeStore.isValidBadgeName(this.badgeName);
	}


	badgeClicked(badge: any) {
		this.clickedBadgeId = badge.id;
		this.showBadge = true;
	}

	async createBadge() {
		if(!this.validBadgeName) {
			return;
		}
		console.log('Creating badge');
		try {
			this.showLoading = true;
			await WebService.createBadge(this.badgeName);
			this.showLoading = false;
			this.overlayMessage = `Badge Created!`;
			this.showCompletedOverlay = true;
			this.badgeName = '';
			setTimeout(() => {
				this.showCompletedOverlay = false;
			}, OverlayShowTime);
		} catch(e) {
			this.showLoading = false;
			await this.$bvModal.msgBoxOk('There was a problem creating your badge', {
				title: 'Error',
				centered: true,
				okTitle: 'Ok'
			});
		}
	}

	async exportCSV() {
		alert('Not Implemented');
	}
}
